import styled from "styled-components";
import { ReactNode } from "react";

interface StyledCardProps {}

const StyledCard = styled.div<StyledCardProps>`
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`;

interface CardProps {
  children?: ReactNode;
  className?: string;
}

const Card = ({ children, className = "" }: CardProps) => {
  return <StyledCard className={className}>{children}</StyledCard>;
};

export default Card;
